"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_1 = require("react");
const SvgExclamationTriangle = (props, ref) => (React.createElement("svg", { ...props, xmlns: "http://www.w3.org/2000/svg", xmlSpace: "preserve", viewBox: "0 0 1024 1024", fill: "currentColor", className: `Icon ${props?.className || ""}`, ref: ref },
    React.createElement("path", { d: "M466.5 318.5c-1.2-25.1 18.2-46.4 43.3-47.6s46.4 18.2 47.6 43.3c.1 1.4.1 2.8 0 4.3v316.4c0 25.1-20.3 45.4-45.4 45.5-25.1 0-45.5-20.4-45.5-45.5zm557.4 574.7c0 72.2-58.6 130.8-130.8 130.8H130.9c-20.3 0-40.3-4.7-58.5-13.8-64.6-32.3-90.8-110.9-58.5-175.5L395 72.3C417 27.9 462.4-.2 512 0c49.6-.2 95 27.9 117 72.3l381.1 762.4c9.1 18.2 13.8 38.2 13.8 58.5m-90.1-20.3L552.7 110.4c-7.6-15.5-23.4-25.3-40.7-25.1-17.3-.1-33.1 9.7-40.7 25.2L90.2 872.9c-15.1 30.2 6.9 65.8 40.7 65.8h762.2c33.8 0 55.8-35.6 40.7-65.8M512 740c-34.2 0-62 27.8-62 62s27.8 62 62 62 62-27.8 62-62-27.8-62-62-62" })));
const ForwardRef = (0, react_1.forwardRef)(SvgExclamationTriangle);
exports.default = ForwardRef;
